<template>
  <div :class="className" :style="{height:'3rem',width:width}" />
</template>

<script>
/* global echarts, $config */
import resize from './mixins/resize'
import { getparkList } from '../../api/parkInfo'

 
export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '3.125rem'
    },
    chartData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chart: null,
      mapData: [],
      zoom:8,
      itemUrl:'',
      chartData:''
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.getParkInfo();
      
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {

     getParkInfo () {
      getparkList().then(resp => {
        if (resp.errmsg === 'ok') {    
          this.mapData = resp.data// 总数据
          this.zoom = this.mapData[0].managerId==1?8:14
          this.initChart();
        }
      }).catch(e => {
        console.log(e)
      })
    },

    initChart () {
  
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)

    },
    setOptions (expectedData) {
      this.chart.setOption({
        backgroundColor: 'transparent',
        title: {
          text: '',
          subtext: '',
          left: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        bmap: {
          center: [this.mapData[0].longitude,this.mapData[0].latitude],
          zoom: this.zoom,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                'featureType': 'water',
                'elementType': 'all',
                'stylers': {
                  'color': '#044161'
                }
              },
              {
                'featureType': 'land',
                'elementType': 'all',
                'stylers': {
                  'color': '#283443'
                }
              },
              {
                'featureType': 'boundary',
                'elementType': 'geometry',
                'stylers': {
                  'color': '#064f85'
                }
              },
              {
                'featureType': 'railway',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'highway',
                'elementType': 'geometry',
                'stylers': {
                  'color': '#004981'
                }
              },
              {
                'featureType': 'highway',
                'elementType': 'geometry.fill',
                'stylers': {
                  'color': '#005b96',
                  'lightness': 1
                }
              },
              {
                'featureType': 'highway',
                'elementType': 'labels',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'arterial',
                'elementType': 'geometry',
                'stylers': {
                  'color': '#004981'
                }
              },
              {
                'featureType': 'arterial',
                'elementType': 'geometry.fill',
                'stylers': {
                  'color': '#00508b'
                }
              },
              {
                'featureType': 'poi',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'green',
                'elementType': 'all',
                'stylers': {
                  'color': '#056197',
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'subway',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'manmade',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'local',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'arterial',
                'elementType': 'labels',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'boundary',
                'elementType': 'geometry.fill',
                'stylers': {
                  'color': '#029fd4'
                }
              },
              {
                'featureType': 'building',
                'elementType': 'all',
                'stylers': {
                  'color': '#1a5787'
                }
              },
              {
                'featureType': 'label',
                'elementType': 'labels.text.fill',
                'stylers': {
                  'color': '#009e96'
                }
              },
              {
                'featureType': 'label',
                'elementType': 'labels.text.stroke',
                'stylers': {
                  'color': '#283443'
                }
              }
            ]
          }
        },
        series: [
          {
            name: '',
            type: 'scatter',
            coordinateSystem: 'bmap',
            data: expectedData,
            tooltip: {
               formatter: () => {
                    return ''  
                  },
            },
            symbol: 'image://static/images/logo.png', // 图标路径
            symbolSize: $config.symbolSize, // 图标大小
            label: {
                normal: {
                  formatter: (params) => {                  
                    return `${params.name}` // 名称，具体按你实际字段命名
                  }, 
                  position: 'top',
                  padding: 15,
                  borderRadius: 8,
                  backgroundColor: 'rgba(13, 25, 60, 0.8)',
                  borderColor: 'rgba(54, 229, 255, 1)',
                  color: '#ffffff',
                  borderWidth: 2,
                  fontSize: 18,
                  show: false,
                  rich: {
                    name: {
                      fontSize: 14,
                      align: 'center',
                      padding: 10
                    }
                  }
                },
                emphasis: {
                  show: true
                }
              },
              itemStyle: {
                normal: {                
                },
                label: {
                  show: true
                }
              }
          }
        ]
      })

      this.chart.on('finished', function () {
        
        var bdElements = document.getElementsByClassName(' anchorBL')
        if (bdElements && bdElements.length) {
          for (var i = 0; i < bdElements.length; i++) {
            bdElements[i].style.display = 'none'
          }
        }
      })


      this.chart.on('click', (params) => {
        // console.log('parkChange',this.zoom)
        this.$emit('parkChange', params.dataIndex, params.value[2])

      })
    }


    
  }
}
</script>
</style>


// WEBPACK FOOTER //
// src/components/index/mapChart.vue